export enum UserLoginRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  TOPUP_ADMIN = 'TOPUP_ADMIN',
  LUCKY_DRAW_ADMIN = 'LUCKY_DRAW_ADMIN',
  REDEEM_PAYMENT_ADMIN = 'REDEEM_PAYMENT_ADMIN',
  AUDIT_ADMIN = 'AUDIT_ADMIN',
  ACCOUNT_ADMIN = 'ACCOUNT_ADMIN',
  LMS_ADMIN = 'LMS_ADMIN',
}
